import { Accordion } from "@gluestack-ui/themed";
import { CardInfoCollapse } from "@repo/core/components/layout/CardInfoCollapse";
import { FinancialServiceListAnimatedProps } from "@repo/core/components/layout/FinancialServicesListAnimated/types";

export const FinancialServicesListAnimated = ({
  financialServices,
  onSelectFinancialService,
  selectedFinancialService
}: FinancialServiceListAnimatedProps) => {
  return (
    <Accordion
      onValueChange={(id) => onSelectFinancialService(id[0])}
      value={[selectedFinancialService || ""]}
      p="$1"
      gap="$4"
      borderRadius="$lg"
      position="relative"
    >
      {financialServices.map((item) => (
        <CardInfoCollapse
          key={item.id}
          id={item.id}
          items={item.items}
          title={item.title}
          subtitle={item.subtitle}
          isActive={item.id === selectedFinancialService}
        />
      ))}
    </Accordion>
  );
};
